"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./configuration");
var ImageProvider = (function () {
    function ImageProvider() {
    }
    ImageProvider.getPencilSquareImage = function () {
        var image = ImageProvider.createHTMLImage("iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABAlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Tsa+AAAAVXRSTlMAAQIDBAUGBwgKCwwPERIXGxwgIiUqLTE1Njo7PkBERUdNUFJUVVZZXF1jZGxtb3BxdHh8fn+Cg4WGiIuOkpeYmpudqKqwt7zAwcjc4uTm6Ovt7/n9ajigqAAAAQ9JREFUOMu90tdSwlAYReF9oiJqYkFRUREb9gqKsVEssYKN9f6v4gXCBPy9ZV+dyfomk5kTqU9zXnyup8480LPm3aDkCi+zkqQ8f1d28u6BjKQp2Ep63RuWlHwFmJdu2LU+alEjbwDTesc3+i3bGmsABUHC6s+syf+AlAVcjWwacgo+52QAVyOb+gYWNCADuOpvh1EZINaXZABX6fScDBDrqzKAq/CUbvW8DODKndvYkQFcmdP1Vt+TBc4IpQ2AfZkgQpI24UTyH00QLkslipKrYwJCXXAuaYh/AHClblAnaB9LURRFRUmSz1f7acix8UcdUGkfgyZHQaJ7wSFMdnAGayux141f1ntq43pCfdwPB1Bdanpj6esAAAAASUVORK5CYII=");
        return ImageProvider.createZebraImagePanel(image);
    };
    ImageProvider.getWarningImage = function () {
        var image = ImageProvider.createHTMLImage("iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAyVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACqPCdOAAAAQnRSTlMAAQIDBgcIERITFCMkJSYnNjg6PD0+P0BBRUlKTVFVWFxdXl9hZm1ze4KDhYalpqiqq62vsLLKzM7P5ujp7e/5+/3r3EMzAAAA8ElEQVQYGZXBiVqCQBgF0Ovk1ma7maUVrTYtUpYpFHrf/6H6GWBIZejrHPxXpYJS+1F0ghINigbcXiie4bRFYxMuYxofcDhk6gCFVMDUVKHIJa0LFKhFtKIaVj2Q7EJ0SQ6wokmxC7FH0cSyIUUbokMxxJIWY6cQZ4xtY9EnY32Ic8bGWNCmcQ1xQ+MIv6iQxi3EHY1AIXfFxD3EgAkPVn3GxJMSPhNRHZlHFtJIbdBhHYlXZnwlfGZ8GDu0NISm1UJsQktDaFoTiA5zGkIzdwyshcxN+71eP2AuVPBYysM3S33hnaVGqI7mdJq/VfGXH4F1eT+41LVtAAAAAElFTkSuQmCC");
        return ImageProvider.createZebraImagePanel(image);
    };
    ImageProvider.createHTMLImage = function (base64Infos) {
        var image = new Image();
        image.src = "data:image/png;base64," + base64Infos;
        return image;
    };
    ImageProvider.createZebraImagePanel = function (image) {
        var imagePan = new zebra.ui.ImagePan(image);
        imagePan.setPreferredSize(configuration_1.PlanConfiguration.iconSize, configuration_1.PlanConfiguration.iconSize);
        var thePanel = new zebra.ui.Panel();
        thePanel.setLayout(new zebra.layout.FlowLayout());
        thePanel.add(imagePan);
        return thePanel;
    };
    return ImageProvider;
}());
exports.ImageProvider = ImageProvider;
//# sourceMappingURL=imageProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/imageProvider.js
// module id = 30
// module chunks = 0